import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@rekonas/auth";
import { queryClient } from "@rekonas/data-access";
import { App } from "./App";
import "./index.css";
import "@rekonas/signal-viewer/styles.css";

async function installDevFixtures() {
  if (import.meta.env.DEV && import.meta.env.VITE_OPERATIONAL_DEV_FIXTURES === "1") {
    const { installOperationalDevFixtures } = await import("./devFixtures");
    installOperationalDevFixtures();
  }
}

void installDevFixtures().then(() => createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
));
